module.exports = __webpack_public_path__ + "img/product_9.63f80ce.webp";